import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { graphql } from 'gatsby';

import { rem } from '../../utilities/style';
import { colors } from '../../theme/colors';
import { media } from '../../theme/media';
import stacking from '../../theme/stacking';
import { containerStyles } from '../../styles/layout';

import Link from '../Link';
import TextRenderer from '../TextRenderer';

const Container = styled.div`
  position: sticky;
  z-index: ${stacking.navbar - 1};
  background: ${colors.white};
  overflow-x: auto;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, .10);
  top: ${rem(56)};

  ${media('>small')} {
    top: ${rem(70)};
  }

  ${media('>nav')} {
    top: ${rem(90)};
  }
`;

const NavWrapper = styled.ul`
  ${containerStyles.regular}
  display: flex;
`;

const NavItem = styled.li`

  &:first-of-type {
    margin-left: ${rem(-12)};
  }

  &:last-of-type {
    margin-right: ${rem(-12)};
  }
`;

const NavLink = styled(Link)`
  display: block;
  padding: ${rem(12)};
  font-size: ${rem(14)};
  color: ${colors.gray['600']};

  ${media('>tiny')} {
    font-size: ${rem(16)};
  }

  &:focus,
  &:hover {
    color: ${colors.blue['800']};
  }
`;

const InlineNav = ({ navigationItems }) => (
  <Container>
    <NavWrapper>
      {navigationItems && navigationItems.map(({ title, url }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <NavItem key={index}>
          <NavLink
            to={url}
            activeStyle={{ fontWeight: 'bold', color: colors.black }}
          >
            <TextRenderer text={title} />
          </NavLink>
        </NavItem>
      ))}
    </NavWrapper>
  </Container>
);

InlineNav.propTypes = {
  navigationItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string
    })
  )
};

export const query = graphql`
  fragment InlineNavigationFragment on ContentfulInlineNavigation {
    __typename
    navigationItems {
      title
      url
    }
    personalizations {
      ...PersonalizationFragment
    }
  }
`;

export default InlineNav;
